import { ResolvedMarketingCampaign } from "resolvers/data/marketingCampaignResolver";
import { findPromo, findPromoForResponseVehicle } from "resolvers/data/pdp/pdpPromoRowResolver";
import { ResolvedVehicleCampaignTag } from "resolvers/data/vehicleCampaignTagResolver";
import { ResponseVehicle } from "services/motorpoint/shortlist";
import { VehicleService } from "./vehicle";

export const vehicleImageOverlayService = () => {
    const getImageOverlayForVehicle = (
        vehicle: VehicleService.Vehicle,
        marketingCampaigns: ResolvedMarketingCampaign[] | null
    ): string | undefined => {
        if (!marketingCampaigns?.length) {
            return undefined;
        }

        for (const marketingCampaign of marketingCampaigns) {
            const matchingPromo = findPromo(vehicle, marketingCampaign.pdpPromo, true);
            if (matchingPromo) {
                return marketingCampaign.overlayImage?.value[0]?.url;
            }
        }

        return undefined;
    };

    const getImageOverlayForResponseVehicle = (
        responseVehicle: ResponseVehicle,
        marketingCampaigns: ResolvedMarketingCampaign[] | null
    ): string | undefined => {
        if (!marketingCampaigns?.length) {
            return undefined;
        }

        for (const marketingCampaign of marketingCampaigns) {
            const matchingPromo = findPromoForResponseVehicle(
                responseVehicle,
                marketingCampaign.pdpPromo,
                true
            );
            if (matchingPromo) {
                return marketingCampaign.overlayImage?.value[0]?.url;
            }
        }

        return undefined;
    };

    const getCustomOverlayForResponseVehicle = (
        responseVehicle: ResponseVehicle,
        marketingCampaigns: ResolvedMarketingCampaign[] | null
    ): ResolvedVehicleCampaignTag | undefined => {
        if (!marketingCampaigns?.length) {
            return undefined;
        }

        for (const marketingCampaign of marketingCampaigns) {
            const matchingPromo = findPromoForResponseVehicle(
                responseVehicle,
                marketingCampaign.pdpPromo,
                true
            );
            if (matchingPromo) {
                return marketingCampaign.vehicleTileTag;
            }
        }
        return undefined;
    };

    return {
        getImageOverlayForVehicle,
        getImageOverlayForResponseVehicle,
        getCustomOverlayForResponseVehicle,
    };
};
